import { ErrorBoundary } from '@zenbusiness/application-commons-logging';

import { ErrorStateSection } from '#client/components/ErrorStateSection';

import BusinessProfile from './BusinessProfile';

/**
 * Entry point for the Business Profile page.
 * Wraps the profile subtree with an ErrorBoundary so failures (e.g. a
 * ProfileQuery REGISTERED_AGENT_CONTACT_FAILED resolver error) show an
 * inline fallback rather than collapsing the dashboard shell.
 */
export default function BusinessProfileGateway() {
  return (
    <ErrorBoundary id="src/pages/BusinessProfileGateway" fallback={<ErrorStateSection title="Business Profile" />}>
      <BusinessProfile />
    </ErrorBoundary>
  );
}
